import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Phone, Mail, Clock, ExternalLink } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();
  const address = 'Kalustetie 1, 01720 Vantaa';
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  const embedUrl = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

  return (
    <section id="contact" className="py-24 bg-[#F7F0E3] relative">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-[#B8934A] mb-4">
            <span className="w-10 h-[1px] bg-[#B8934A]" />
            <span className="text-xs tracking-[0.3em] uppercase font-medium">{t.contact.heading}</span>
            <span className="w-10 h-[1px] bg-[#B8934A]" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1F2A24] mb-4 font-semibold">
            {t.contact.subheading}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-[#EDE4D2] flex flex-col">
            <div className="space-y-7 flex-1">
              <div className="flex gap-5">
                <div className="shrink-0 w-12 h-12 rounded-full bg-[#7A1F25] flex items-center justify-center">
                  <MapPin className="text-[#D4A94B]" size={20} />
                </div>
                <div>
                  <h3 className="font-serif text-[#B8934A] text-xs tracking-[0.25em] uppercase mb-1">{t.contact.address}</h3>
                  <p className="text-[#1F2A24] text-lg font-medium">Kalustetie 1</p>
                  <p className="text-[#6B6257]">01720 Vantaa</p>
                </div>
              </div>

              <div className="flex gap-5">
                <div className="shrink-0 w-12 h-12 rounded-full bg-[#7A1F25] flex items-center justify-center">
                  <Phone className="text-[#D4A94B]" size={20} />
                </div>
                <div>
                  <h3 className="font-serif text-[#B8934A] text-xs tracking-[0.25em] uppercase mb-1">{t.contact.phone}</h3>
                  <a href="tel:+358407611347" className="text-[#1F2A24] text-lg font-medium hover:text-[#B8934A] transition-colors">
                    040 7611347
                  </a>
                </div>
              </div>

              <div className="flex gap-5">
                <div className="shrink-0 w-12 h-12 rounded-full bg-[#7A1F25] flex items-center justify-center">
                  <Mail className="text-[#D4A94B]" size={20} />
                </div>
                <div>
                  <h3 className="font-serif text-[#B8934A] text-xs tracking-[0.25em] uppercase mb-1">{t.contact.email}</h3>
                  <a href="mailto:info@ravintolalamaria.fi" className="text-[#1F2A24] text-lg font-medium hover:text-[#B8934A] transition-colors break-all">
                    info@ravintolalamaria.fi
                  </a>
                </div>
              </div>

              <div className="flex gap-5">
                <div className="shrink-0 w-12 h-12 rounded-full bg-[#7A1F25] flex items-center justify-center">
                  <Clock className="text-[#D4A94B]" size={20} />
                </div>
                <div>
                  <h3 className="font-serif text-[#B8934A] text-xs tracking-[0.25em] uppercase mb-1">{t.contact.hours}</h3>
                  <p className="text-[#1F2A24]"><span className="font-medium">{t.info.weekdays}</span> <span className="text-[#6B6257]">8–18</span></p>
                  <p className="text-[#1F2A24]"><span className="font-medium">{t.info.weekend}</span> <span className="text-[#6B6257]">— {t.info.closed}</span></p>
                </div>
              </div>
            </div>

            <a
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center justify-center gap-2 bg-[#7A1F25] hover:bg-[#5A1219] text-white px-6 py-3.5 rounded-full font-medium tracking-wide transition-all hover:shadow-lg"
            >
              {t.contact.directions}
              <ExternalLink size={16} />
            </a>
          </div>

          <div className="rounded-2xl overflow-hidden shadow-sm border border-[#EDE4D2] min-h-[400px] bg-white">
            <iframe
              title="Ravintola La Maria location"
              src={embedUrl}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '400px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
